import { render, staticRenderFns } from "./not_available_area.vue?vue&type=template&id=5602fca5&scoped=true&"
import script from "./not_available_area.vue?vue&type=script&lang=js&"
export * from "./not_available_area.vue?vue&type=script&lang=js&"
import style0 from "./not_available_area.vue?vue&type=style&index=0&id=5602fca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5602fca5",
  null
  
)

export default component.exports